import { FC, PropsWithChildren } from 'react';
import { Paper } from '@mui/material';

import { appShellInertDomProps } from '@/hooks/useInertBackground';
import { useMainLayoutContext } from '../Context/useMainLayoutContext';

export const LayoutContainer: FC<PropsWithChildren> = ({ children }) => {
  const { containerSx } = useMainLayoutContext();

  return (
    <Paper
      id="app-layout-container"
      {...appShellInertDomProps}
      sx={[
        (theme) => ({
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          position: 'relative',
          m: 0,
          p: 0,
          backgroundColor: theme.palette.background.default,

          '&::before': {
            content: '""',
            position: 'fixed',
            inset: 0,
            backgroundColor: theme.palette.background.paper,
            zIndex: -1,
          },
        }),

        ...(Array.isArray(containerSx) ? containerSx : [containerSx]),
      ]}
    >
      {children}
    </Paper>
  );
};
